import React from "react";
import { Entry } from "contentful";
import { BrandInvestmentReadyToInvest } from "@tiicker/util/lib/contentful/types";
import styles from "./ReadyToInvest.module.scss";

type Props = {
  readyToInvest: Entry<BrandInvestmentReadyToInvest>;
  investUrl: string;
};

const ReadyToInvest: React.FC<Props> = ({
  readyToInvest,
  investUrl,
}: Props) => {
  if (!readyToInvest) return null;

  const { title, buttonCopy, buttonCopyHex, buttonHex, borderHex } =
    readyToInvest.fields;

  return (
    <div
      className={styles.ReadyToInvest}
      style={{
        borderColor: borderHex,
        borderStyle: "solid",
        borderWidth: "3px",
      }}
    >
      <h3 className={styles.ReadyToInvest__title}>{title}</h3>
      <button
        className={styles.ReadyToInvest__button}
        style={{ color: buttonCopyHex, backgroundColor: buttonHex }}
        onClick={() => window.open(investUrl, "_blank", "noopener, noreferrer")}
      >
        {buttonCopy}
      </button>
    </div>
  );
};

export default ReadyToInvest;
